export const reverseName = (name: string): string => {
    return name.split(' ').reverse().join(' ');
};
